<template>
  <v-app>
    <div class="row">
      <div class="col-12">
        <div class="card ">
          <div class="card-header">
            <div class="card-title pt-3 px-3 d-flex justify-content-between">
              <div class="breadcrumb-left">
                <h4>  Books issued</h4>
                <div class="breadcrumb-sub-header">
                  <router-link :to="{ name: 'library' }"> Library</router-link>
                  \   Books issued
                </div>
              </div>

            </div>
          </div>
          <div class="card-body">
            <div class="table-responsive">
              <v-skeleton-loader
                  type="table-thead"
                  v-if="isLoading"
              >
              </v-skeleton-loader>

              <v-skeleton-loader
                  v-if="isLoading"
                  type="table-row-divider@25"
              >
              </v-skeleton-loader>
              <div v-if="current_issued.length>0">
                <span class="font-weight-black">Currently issued :</span> [{{ `${current_issued.length}` }}]
              </div>
              <table class="table" v-if="!isLoading">
                  <thead>
                    <tr class="px-3">
                      <th class="px-3">#</th>
                      <th class="px-3" style="max-width: 300px !important; white-space: pre-wrap;">Book title</th>
                      <th class="px-3">Info</th>
                      <th class="pr-3 text-center">Status</th>
                    </tr>
                  </thead>
                  <tbody>
                  <tr v-show="current_issued.length >  0"  v-for="(issue, i) of current_issued" :key="i">
                    <td class="px-3">
                      <div class="text-secondary">
                        <img v-if="issue.book_image_path && issue.book_image_path.thumb" :src="issue.book_image_path.thumb"
                             width="80"
                             alt="">
                        <img v-else src="@/assets/media/images/open-book.png" alt="" width="80">
                      </div>
                      <div v-if="issue.book_no" class="text-secondary">
                        <span class="font-weight-black">
                          Book no.
                        </span> {{ issue.book_no }}
                      </div>
                      <div v-if="issue.book_accession_no" class="text-secondary">
                         <span class="font-weight-black">
                        Accession no.
                         </span> :{{ issue.book_accession_no }}
                      </div>
                    </td>
                    <td class="px-3" style="max-width: 300px !important; white-space: pre-wrap;">
                      <span  class="font-weight-black">
                        {{ issue.book_title }}
                      </span>
                    </td>
                    <td>
                      <div v-if="issue.book_author" class="text-secondary">
                        <span class="font-weight-black">Author :</span>{{ issue.book_no }}
                      </div>
                      <div v-if="issue.book_publisher" class="text-secondary">
                        <span class="font-weight-black">Publisher :</span>{{ issue.book_publisher }}
                      </div>
                      <div v-if="issue.book_publication" class="text-secondary">
                        <span class="font-weight-black">Publication :</span>{{ issue.book_publication }}
                      </div>
                      <div v-if="issue.issue_date_text" class="text-secondary">
                        <span class="font-weight-black">Issued date :</span>{{ issue.issue_date_text }}
                      </div>
                      <div v-if="issue.due_return_date_text" class="text-secondary">
                        <span class="font-weight-black">Due date :</span>{{ issue.due_return_date_text }}
                      </div>
                      <div v-if="issue.return_date_text" class="text-secondary">
                        <span class="font-weight-black">Return date :</span>{{ issue.return_date_text }}
                      </div>
                      <div v-if="issue.renew_date_text" class="text-secondary">
                        <span class="font-weight-black">Renew date :</span>{{ issue.renew_date_text }}
                      </div>
                    </td>
                    <td>
                      <div class="text-secondary">
                        <span class="font-weight-black"> Renew Required : </span> <span class="badge" :class="issue.renew_required?'badge-danger':'badge-primary'" v-text="issue.renew_required?'YES':'NO'"></span>
                      </div>
                    </td>
                  </tr>
                  <tr v-show="current_issued.length == 0">
                    <td class="text-center" colspan="4">
                      <strong>No items added.</strong>
                    </td>
                  </tr>
                  </tbody>
              </table>
            </div>
<!--            <div
                class="wizard wizard-2"
                id="kt_wizard_v2"
                data-wizard-state="step-first"
                data-wizard-clickable="true"
            >
              <div class="wizard-body py-8 px-8 py-lg-10 px-lg-10">

                <v-card class="mt-3">
                  <div class="col-12" v-if="current_issued.length>0">
                    <v-card-title>
                      Currently issued [{{ `${current_issued.length}` }}]
                    </v-card-title>
                    <template v-if="!isLoading && current_issued.length>0">
                      <div class="row">
                        <div class="col-lg-6" v-for="(issue, index) of current_issued" :key="index">
                          <div class="card mb-8">
                            <div class="card-body">
                              <div class="p-6">
                                &lt;!&ndash;                    <h2 class="text-dark mb-8">Buying Product &amp; Support</h2>&ndash;&gt;
                                &lt;!&ndash;begin::Accordion&ndash;&gt;
                                <div class="accordion accordion-light accordion-light-borderless accordion-svg-toggle"
                                     id="accordionExample7">
                                  &lt;!&ndash;begin::Item&ndash;&gt;
                                  <div class="card">
                                    &lt;!&ndash;begin::Header&ndash;&gt;
                                    <div class="card-header" id="headingOne7">
                                      <div class="card-title" data-toggle="collapse" data-target="#collapseOne7"
                                           aria-expanded="true" role="button">
																	<span class="svg-icon svg-icon-primary">
																		&lt;!&ndash;begin::Svg Icon | path:assets/media/svg/icons/Navigation/Angle-double-right.svg&ndash;&gt;
																		<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                         width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
																			<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
																				<polygon points="0 0 24 0 24 24 0 24"/>
																				<path
                                            d="M12.2928955,6.70710318 C11.9023712,6.31657888 11.9023712,5.68341391 12.2928955,5.29288961 C12.6834198,4.90236532 13.3165848,4.90236532 13.7071091,5.29288961 L19.7071091,11.2928896 C20.085688,11.6714686 20.0989336,12.281055 19.7371564,12.675721 L14.2371564,18.675721 C13.863964,19.08284 13.2313966,19.1103429 12.8242777,18.7371505 C12.4171587,18.3639581 12.3896557,17.7313908 12.7628481,17.3242718 L17.6158645,12.0300721 L12.2928955,6.70710318 Z"
                                            fill="#000000" fill-rule="nonzero"/>
																				<path
                                            d="M3.70710678,15.7071068 C3.31658249,16.0976311 2.68341751,16.0976311 2.29289322,15.7071068 C1.90236893,15.3165825 1.90236893,14.6834175 2.29289322,14.2928932 L8.29289322,8.29289322 C8.67147216,7.91431428 9.28105859,7.90106866 9.67572463,8.26284586 L15.6757246,13.7628459 C16.0828436,14.1360383 16.1103465,14.7686056 15.7371541,15.1757246 C15.3639617,15.5828436 14.7313944,15.6103465 14.3242754,15.2371541 L9.03007575,10.3841378 L3.70710678,15.7071068 Z"
                                            fill="#000000" fill-rule="nonzero" opacity="0.3"
                                            transform="translate(9.000003, 11.999999) rotate(-270.000000) translate(-9.000003, -11.999999)"/>
																			</g>
																		</svg>
                                    &lt;!&ndash;end::Svg Icon&ndash;&gt;
																	</span>
                                        <div class="card-label text-dark pl-4">
                                          <span>{{ issue.book_title }}</span>
                                          <span class="float-right"><i class="fas fa-circle" :class="issue.renew_required?'text-danger':'text-success'"></i></span>
                                        </div>
                                      </div>
                                    </div>
                                    &lt;!&ndash;                                <pre>{{issue}}</pre>&ndash;&gt;
                                    &lt;!&ndash;end::Header&ndash;&gt;
                                    &lt;!&ndash;begin::Body&ndash;&gt;
                                    <div id="collapseOne7" class="collapse show" aria-labelledby="headingOne7"
                                         data-parent="#accordionExample7">
                                      <div class="card-body text-dark-50 font-size-lg pl-12">
                                        <div class="row">
                                          <div class="col-8">
                                            <h6 v-if="issue.book_author"><b>Author</b>: {{ issue.book_author }}</h6>
                                            <h6 v-if="issue.book_publisher"><b>Publisher</b>: {{ issue.book_publisher }}</h6>
                                            <h6 v-if="issue.book_publication"><b>Publication</b>: {{ issue.book_publication }}</h6>
                                            <h6 v-if="issue.issue_date_text"><b>Issued date</b>: {{ issue.issue_date_text }}</h6>
                                            <h6 v-if="issue.due_return_date_text"><b>Due date</b>: {{ issue.due_return_date_text }}</h6>
                                            <h6 v-if="issue.return_date_text"><b>Return date</b>: {{ issue.return_date_text }}</h6>
                                            <h6 v-if="issue.renew_date_text"><b>Renew date</b>: {{ issue.renew_date_text }}</h6>
                                            <h6><b>Renew Required</b> :
                                              <span class="badge" :class="issue.renew_required?'badge-danger':'badge-primary'" v-text="issue.renew_required?'YES':'NO'"></span>
                                            </h6>
                                          </div>
                                          &lt;!&ndash;                                        <pre>{{issue.book_image_path.thumb}}</pre>&ndash;&gt;
                                          <div class="col-4">
                                            <img v-if="issue.book_image_path && issue.book_image_path.thumb" :src="issue.book_image_path.thumb"
                                                 width="100"
                                                 alt="">
                                            <img v-else src="@/assets/media/images/open-book.png" alt="" width="100">
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    &lt;!&ndash;end::Body&ndash;&gt;
                                  </div>
                                  &lt;!&ndash;end::Item&ndash;&gt;
                                  &lt;!&ndash;end::Item&ndash;&gt;
                                  &lt;!&ndash;begin::Item&ndash;&gt;
                                  &lt;!&ndash;end::Item&ndash;&gt;
                                </div>
                                &lt;!&ndash;end::Accordion&ndash;&gt;
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>

                  </div>
                  <div class="col-12" v-if="previously_issued.length>0">
                    <v-card-title>
                      Previously Issued [{{ `${previously_issued.length}` }}]
                    </v-card-title>
                    <template v-if="!isLoading && previously_issued.length>0">
                      <div class="row">
                        <div class="col-lg-6" v-for="(issue, index) of previously_issued" :key="index">
                          <div class="card mb-8">
                            <div class="card-body">
                              <div class="p-6">
                                &lt;!&ndash;                    <h2 class="text-dark mb-8">Buying Product &amp; Support</h2>&ndash;&gt;
                                &lt;!&ndash;begin::Accordion&ndash;&gt;
                                <div class="accordion accordion-light accordion-light-borderless accordion-svg-toggle"
                                     id="accordionExample7">
                                  &lt;!&ndash;begin::Item&ndash;&gt;
                                  <div class="card">
                                    &lt;!&ndash;begin::Header&ndash;&gt;
                                    <div class="card-header" id="headingOne7">
                                      <div class="card-title" data-toggle="collapse" data-target="#collapseOne7"
                                           aria-expanded="true" role="button">
																	<span class="svg-icon svg-icon-primary">
																		&lt;!&ndash;begin::Svg Icon | path:assets/media/svg/icons/Navigation/Angle-double-right.svg&ndash;&gt;
																		<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                         width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
																			<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
																				<polygon points="0 0 24 0 24 24 0 24"/>
																				<path
                                            d="M12.2928955,6.70710318 C11.9023712,6.31657888 11.9023712,5.68341391 12.2928955,5.29288961 C12.6834198,4.90236532 13.3165848,4.90236532 13.7071091,5.29288961 L19.7071091,11.2928896 C20.085688,11.6714686 20.0989336,12.281055 19.7371564,12.675721 L14.2371564,18.675721 C13.863964,19.08284 13.2313966,19.1103429 12.8242777,18.7371505 C12.4171587,18.3639581 12.3896557,17.7313908 12.7628481,17.3242718 L17.6158645,12.0300721 L12.2928955,6.70710318 Z"
                                            fill="#000000" fill-rule="nonzero"/>
																				<path
                                            d="M3.70710678,15.7071068 C3.31658249,16.0976311 2.68341751,16.0976311 2.29289322,15.7071068 C1.90236893,15.3165825 1.90236893,14.6834175 2.29289322,14.2928932 L8.29289322,8.29289322 C8.67147216,7.91431428 9.28105859,7.90106866 9.67572463,8.26284586 L15.6757246,13.7628459 C16.0828436,14.1360383 16.1103465,14.7686056 15.7371541,15.1757246 C15.3639617,15.5828436 14.7313944,15.6103465 14.3242754,15.2371541 L9.03007575,10.3841378 L3.70710678,15.7071068 Z"
                                            fill="#000000" fill-rule="nonzero" opacity="0.3"
                                            transform="translate(9.000003, 11.999999) rotate(-270.000000) translate(-9.000003, -11.999999)"/>
																			</g>
																		</svg>
                                    &lt;!&ndash;end::Svg Icon&ndash;&gt;
																	</span>
                                        <div class="card-label text-dark pl-4">
                                          <span>{{ issue.book_title }}</span>
                                          <span class="float-right"><i class="fas fa-circle" :class="issue.renew_required?'text-danger':'text-success'"></i></span>
                                        </div>
                                      </div>
                                    </div>
                                    &lt;!&ndash;                                <pre>{{issue}}</pre>&ndash;&gt;
                                    &lt;!&ndash;end::Header&ndash;&gt;
                                    &lt;!&ndash;begin::Body&ndash;&gt;
                                    <div id="collapseOne7" class="collapse show" aria-labelledby="headingOne7"
                                         data-parent="#accordionExample7">
                                      <div class="card-body text-dark-50 font-size-lg pl-12">
                                        <div class="row">
                                          <div class="col-8">
                                            <h6 v-if="issue.book_author"><b>Author</b> : {{ issue.book_author }}</h6>
                                            <h6 v-if="issue.book_publisher"><b>Publisher</b> : {{ issue.book_publisher }}</h6>
                                            <h6 v-if="issue.book_publication"><b>Publication</b> : {{ issue.book_publication }}</h6>
                                            <h6 v-if="issue.issue_date_text"><b>Issued Date</b> : {{ issue.issue_date_text }}</h6>
                                            <h6 v-if="issue.due_return_date_text"><b>Due Date</b> : {{ issue.due_return_date_text }}</h6>
                                            <h6 v-if="issue.return_date_text"><b>Return Date</b> : {{ issue.return_date_text }}</h6>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    &lt;!&ndash;end::Body&ndash;&gt;
                                  </div>
                                  &lt;!&ndash;end::Item&ndash;&gt;
                                  &lt;!&ndash;end::Item&ndash;&gt;
                                  &lt;!&ndash;begin::Item&ndash;&gt;
                                  &lt;!&ndash;end::Item&ndash;&gt;
                                </div>
                                &lt;!&ndash;end::Accordion&ndash;&gt;
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>

                  </div>
                </v-card>

              </div>
            </div>-->
          </div>
        </div>
      </div>
    </div>


    <template v-if="!isLoading && current_issued.length<=0 && previously_issued.length<=0">
      <div class="row mt-2">
        <div class="col-md-12 text-center">
          <v-card class="p-20">
            <img src="@/assets/media/images/no-data-found.png">
            <h5 class="mt-10">No books are issued under your name. <br/>Books issued from Library under your name will appear here.</h5>
          </v-card>
        </div>
      </div>
    </template>
  </v-app>
</template>

<script>
import IssueService from "@/core/services/library/issue/IssueService";

const issueService = new IssueService();
export default {
  name: "Index",
  computed: {
    user() {
      return this.$store.getters.currentUser;
    },
  }, data() {
    return {
      isLoading:true,
      current_issued: [],
      previously_issued: []
    }
  },
  mounted() {
    this.getUserIssue('currently')
    this.getUserIssue('previously')
  },
  methods: {
    getUserIssue(type) {
      this.isLoading = true
      issueService.issuedBook(type).then(response => {
        if (type == 'currently') {
          this.current_issued = response.data.books
        } else {
          this.previously_issued = response.data.books
        }
      }).finally(error=>{
        this.isLoading = false
      })
    },
  }
}
</script>

<style scoped>

</style>
